import {
  AttemptStatusType,
  ProblemType,
  stringToProblemType,
} from "../../../config/enums";

interface SingleCorrectTypeData {
  qType: ProblemType.SingleCorrect;
  options: {
    id: string;
    description: string;
  }[];
}
interface NumericalTypeData {
  qType: ProblemType.Numerical;
}
interface UnkownTypeData {
  qType: ProblemType.Unkown;
}

export type IQuestion = {
  id: string;
  title: string;
  description: string;
  tags: {
    name: string;
  }[];
  startTime: Date;
  status: AttemptStatusType;
  userAnswer: string | null;
  difficulty: string;
  postSubmit: {
    correctAnswer: string;
    solution: string;
    endTime: Date;
  } | null;
} & (SingleCorrectTypeData | NumericalTypeData | UnkownTypeData);

/** API Response for Get Question */
export interface GetQuestionApiResponse {
  title: string;
  description: string;
  options?: {
    description: string;
    reference_id: string;
  }[];
  tags?: {
    name: string;
  }[];
  slug: string;
  question_type: string;
  status: string;
  time_taken: number;
  question_start_time: string;
  difficulty: string;
  post_submit: {
    question_end_time: string;
    selected_answer: string;
    correct_answer: string;
    solution: string;
  } | null;
}

export const parseGetQuestionResponse = (
  response: GetQuestionApiResponse,
): IQuestion => {
  // Create base question
  const question = {
    id: response.slug,
    title: response.title,
    description: response.description,
    tags: response.tags ?? [],
    startTime: new Date(response.question_start_time),
    status: response.status as AttemptStatusType,
    userAnswer: response.post_submit?.selected_answer || null,
    difficulty: response.difficulty,
    postSubmit: response.post_submit
      ? {
          correctAnswer: response.post_submit.correct_answer,
          solution: response.post_submit.solution,
          endTime: new Date(response.post_submit.question_end_time),
        }
      : null,
  };
  const qType = stringToProblemType(response.question_type);
  // Handle SingleCorrect or Numerical question types

  switch (qType) {
    case ProblemType.SingleCorrect:
      return {
        ...question,
        qType: ProblemType.SingleCorrect,
        options:
          response.options?.map(option => ({
            id: option.reference_id,
            description: option.description,
          })) ?? [],
      };
    case ProblemType.Numerical:
      return {
        ...question,
        qType: ProblemType.Numerical,
      };
    default:
      return {
        ...question,
        qType: ProblemType.Unkown,
      };
  }
};
